import { ColDef, GridOptions } from '@ag-grid-community/core';
import { commonGridOptions } from '../blotter.service.utils';
import { EBlotterTab } from '../../../enums';
import { IKondorBlotterPositionService } from './kondor-blotter.interface';
import { injectable } from 'inversify';
import { positionBlotterColumns } from './kondor-blotter-position.utils';

@injectable()
export class KondorBlotterPositionMock implements IKondorBlotterPositionService {

    type = 'position' as EBlotterTab;

    gridOptions(): GridOptions {
        return {
            ...commonGridOptions,
        };
    }

    columnDefinitions(): Array<ColDef> {
        return positionBlotterColumns();
    }
}
